var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSuccess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40 1.09338C18.5105 1.09338 1.09375 18.5101 1.09375 39.9996C1.09375 61.4893 18.5105 78.9059 40 78.9059C61.4895 78.9059 78.9062 61.4892 78.9062 39.9996C78.9062 18.5099 61.4895 1.09338 40 1.09338ZM40 75.7934C20.2642 75.7934 4.20625 59.7354 4.20625 39.9995C4.20625 20.2635 20.2642 4.20573 40 4.20573C59.7359 4.20573 75.7937 20.2637 75.7937 39.9995C75.7937 59.7354 59.7359 75.7934 40 75.7934Z",
    fill: "#33B469"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M60.0365 24.7175L33.8934 50.8622L19.9782 36.9502L17.7686 39.16L33.8934 55.2817L62.2311 26.9272L60.0365 24.7175Z",
    fill: "#33B469"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccess);
export default __webpack_public_path__ + "static/media/success.c1f44a4fae0cfbe935803501b6034028.svg";
export { ForwardRef as ReactComponent };